module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timer"
  }, [_c('p', [_vm._v(_vm._s(_vm.time))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d163e33","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timer.vue
// module id = 843
// module chunks = 4